export default {
  data () {
    return {
      periods: [
        {
          id: 'current_month',
          name: this.$t('date_select_this_month'),
          default: false,
          filter: {
            'date[after]': this.$moment.utc().startOf('month').format(),
            'date[before]': this.$moment.utc().endOf('month').format()
          }
        },
        {
          id: 'last_month',
          name: this.$t('date_select_last_month'),
          default: false,
          filter: {
            'date[after]': this.$moment.utc().subtract(1, 'months').startOf('month').format(),
            'date[before]': this.$moment.utc().subtract(1, 'months').endOf('month').format()
          }
        },
        {
          id: 'current_quarter',
          name: this.$t('dashboard_task_period_current_quarter'),
          default: false,
          filter: {
            'date[after]': this.$moment.utc().startOf('quarter').format(),
            'date[before]': this.$moment.utc().endOf('quarter').format()
          }
        },
        {
          id: 'current_year',
          name: this.$t('dashboard_task_period_current_year'),
          default: false,
          filter: {
            'date[after]': this.$moment.utc().startOf('year').format(),
            'date[before]': this.$moment.utc().endOf('year').format()
          }
        },
        {
          id: 'historic',
          name: this.$t('dashboard_task_period_history'),
          default: true,
          filter: {
            'date[after]': undefined,
            'date[before]': undefined
          }
        },
        { name: this.$t('date_select_personalized_range'), id: 'personalized_range' }
      ]
    }
  }
}
